<div class="text-selection">
    @if (crudPermitted && offlineModeDisabled) {
        <i (click)="deleteSelection()"
           aria-hidden="true" class="fa fa-times close-icon grow"></i>
    }
</div>
